import styled from 'styled-components';
import { IconWrapperProps } from './types';

export const IconWrapper = styled.div<IconWrapperProps>`
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &::after {
    content: '${props => (props.isSelected ? '' : '/')}';
    position: absolute;
    color: red;
    font-size: 26px;
    transform: rotate(30deg);
  }
`;

export default {};
